/* You must register this file at "website\src\i18n\en-us" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    trades: {
        menu: {
            index: 'Trades',
            create: 'New',
            list: 'Trades'
        },
        table_titles: {
            id: 'ID',
            exchange: 'Exchange',
            role: 'Role',
            side: 'Side',
            price: 'Price',
            amount: 'Amount',
            fee: 'Fee',
            total: 'Total',
            status: 'Status',
            created_at: 'Time',
            setting: 'Edit / Delete',
        },
        edit: 'Edit a trade'
    }
}
